import { FieldType } from './FieldType';
import { FilterExpressionType } from './FilterExpressionType';
import { ValidationResult } from './ValidationResult';
import { toDateString, toDateTimeString } from './Converters';

interface ColumnOption {
  title: string;
  description?: string;
  fieldName: string;
  fieldType?: FieldType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editable?: (cellValue: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validator?: (cellValue: any, row: any, isNew: boolean) => ValidationResult;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  converter?: (cellValue: any, row: any) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterConverter?: (cellValue: FilterExpressionType) => FilterExpressionType[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  csvExportConverter?: (cellValue: any, row: any) => string;
  dropdownOptions?: { id: number | string | null; title: string }[];
  hidden?: boolean;
  hiddenInAddDialog?: boolean;
  colStyling?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cellStyling?: (cell: any) => { [key: string]: boolean };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
  isHeaderMenuVisible?: boolean;
}

export class Column {
  public title: string;
  public description: string;
  public fieldName: string;
  public fieldType: FieldType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public editable: (cellValue: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public validator: (cellValue: any, row: any, isNew: boolean) => ValidationResult;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public converter: (cellValue: any, row: any) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterConverter: (cellValue: FilterExpressionType) => FilterExpressionType[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public csvExportConverter: (cellValue: any, row: any) => string;
  public dropdownOptions: { id: number | string | null; title: string }[];
  public hidden: boolean;
  public hiddenInAddDialog: boolean;
  public ordering: number | undefined;
  public colStyling: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public cellStyling: ((cell: any) => { [key: string]: boolean }) | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public defaultValue: any | undefined;
  public isHeaderMenuVisible: boolean | undefined;

  constructor(options: ColumnOption) {
    this.title = options.title;
    this.description = options.description ?? '';
    this.fieldName = options.fieldName;
    this.fieldType = options.fieldType ?? 'string';
    this.editable = options.editable ?? (() => false);
    this.validator = options.validator ?? (() => ({ isValid: true, errorMessages: [] }));
    this.converter = options.converter
      ? options.converter
      : Column.determineFallbackConverter(this.fieldType);
    this.filterConverter = options.filterConverter ?? ((cellValue) => [cellValue]);
    this.csvExportConverter = options.csvExportConverter
      ? options.csvExportConverter
      : this.converter;
    this.dropdownOptions = options.dropdownOptions ?? [];
    this.hidden = options.hidden ?? false;
    this.hiddenInAddDialog = options.hiddenInAddDialog ?? false;
    this.colStyling = options.colStyling ?? '';
    this.cellStyling = options.cellStyling ?? undefined;
    this.defaultValue = options.defaultValue ?? undefined;
    this.isHeaderMenuVisible = options.isHeaderMenuVisible ?? true;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  public validate = (value: any, row: any, isNew: boolean): ValidationResult =>
    this.validator(value, row, isNew);

  private static determineFallbackConverter(
    fieldType: FieldType
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): (cellValue: any, row: any) => string {
    if (fieldType == 'date') {
      return (cellValue) => (cellValue ? toDateString(cellValue) : cellValue);
    }
    if (fieldType == 'datetime-local') {
      return (cellValue) => (cellValue ? toDateTimeString(cellValue) : cellValue);
    }
    return (cellValue) => cellValue;
  }
}
